import React from 'react';

export default function PageState({ loading, error, empty, loadingMessage = 'Laden...', children }) {
    if (loading) {
        return <div className="dashboard-state">{loadingMessage}</div>;
    }
    if (error) {
        return <div className="dashboard-state error">{error}</div>;
    }
    if (empty) {
        return <div className="dashboard-state">{empty}</div>;
    }
    return children || null;
}
